export const zapierSettings = {
  integrationZapier: false
};

export type ZapierSettings = typeof zapierSettings;
